/* tslint:disable */
/* eslint-disable */
/**
 * Dataland QA Service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { DatasetJudgementResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { DatasetJudgementState } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { JudgementDetailsPatch } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
/**
 * DatasetJudgementControllerApi - axios parameter creator
 */
export const DatasetJudgementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete dataset judgement object (and by extension data point judgement objects) without deleting the QA reports.
         * @summary Delete dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasetJudgement: async (datasetJudgementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetJudgementId' is not null or undefined
            assertParamExists('deleteDatasetJudgement', 'datasetJudgementId', datasetJudgementId)
            const localVarPath = `/dataset-judgements/{datasetJudgementId}`
                .replace(`{${"datasetJudgementId"}}`, encodeURIComponent(String(datasetJudgementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a dataset judgement object by its id.
         * @summary Get a dataset judgement object by its id.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetJudgement: async (datasetJudgementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetJudgementId' is not null or undefined
            assertParamExists('getDatasetJudgement', 'datasetJudgementId', datasetJudgementId)
            const localVarPath = `/dataset-judgements/{datasetJudgementId}`
                .replace(`{${"datasetJudgementId"}}`, encodeURIComponent(String(datasetJudgementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all dataset judgement objects associated with the specified dataset id.
         * @summary Get dataset judgement objects by dataset id.
         * @param {string} datasetId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetJudgementsByDatasetId: async (datasetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getDatasetJudgementsByDatasetId', 'datasetId', datasetId)
            const localVarPath = `/dataset-judgements/{datasetId}/datasetId`
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates acceptedSource, companyIdOfAcceptedQaReport and customValue of a data point within a dataset judgement.
         * @summary Patch judgement details for a data point
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {string} dataPointType The data point type of the provided data point.
         * @param {JudgementDetailsPatch} judgementDetailsPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJudgementDetails: async (datasetJudgementId: string, dataPointType: string, judgementDetailsPatch: JudgementDetailsPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetJudgementId' is not null or undefined
            assertParamExists('patchJudgementDetails', 'datasetJudgementId', datasetJudgementId)
            // verify required parameter 'dataPointType' is not null or undefined
            assertParamExists('patchJudgementDetails', 'dataPointType', dataPointType)
            // verify required parameter 'judgementDetailsPatch' is not null or undefined
            assertParamExists('patchJudgementDetails', 'judgementDetailsPatch', judgementDetailsPatch)
            const localVarPath = `/dataset-judgements/{datasetJudgementId}/data-points/{dataPointType}`
                .replace(`{${"datasetJudgementId"}}`, encodeURIComponent(String(datasetJudgementId)))
                .replace(`{${"dataPointType"}}`, encodeURIComponent(String(dataPointType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(judgementDetailsPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a new dataset judgement object.
         * @summary Upload new dataset judgement object.
         * @param {string} datasetId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDatasetJudgement: async (datasetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('postDatasetJudgement', 'datasetId', datasetId)
            const localVarPath = `/dataset-judgements/{datasetId}`
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set yourself as the judge of the dataset judgement object. Other users cannot modify this object.
         * @summary Change the Judge of a dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJudge: async (datasetJudgementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetJudgementId' is not null or undefined
            assertParamExists('setJudge', 'datasetJudgementId', datasetJudgementId)
            const localVarPath = `/dataset-judgements/{datasetJudgementId}/judge`
                .replace(`{${"datasetJudgementId"}}`, encodeURIComponent(String(datasetJudgementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify state of the dataset judgement object. Approves or rejects associated data set. Uploads new datapoints and approves them, rejects unneeded datapoints.
         * @summary Change the state of a dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {DatasetJudgementState} datasetJudgementState The state of the dataset judgement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJudgementState: async (datasetJudgementId: string, datasetJudgementState: DatasetJudgementState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetJudgementId' is not null or undefined
            assertParamExists('setJudgementState', 'datasetJudgementId', datasetJudgementId)
            // verify required parameter 'datasetJudgementState' is not null or undefined
            assertParamExists('setJudgementState', 'datasetJudgementState', datasetJudgementState)
            const localVarPath = `/dataset-judgements/{datasetJudgementId}/state`
                .replace(`{${"datasetJudgementId"}}`, encodeURIComponent(String(datasetJudgementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (datasetJudgementState !== undefined) {
                localVarQueryParameter['datasetJudgementState'] = datasetJudgementState;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasetJudgementControllerApi - functional programming interface
 */
export const DatasetJudgementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasetJudgementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete dataset judgement object (and by extension data point judgement objects) without deleting the QA reports.
         * @summary Delete dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDatasetJudgement(datasetJudgementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.deleteDatasetJudgement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a dataset judgement object by its id.
         * @summary Get a dataset judgement object by its id.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetJudgementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetJudgement(datasetJudgementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.getDatasetJudgement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all dataset judgement objects associated with the specified dataset id.
         * @summary Get dataset judgement objects by dataset id.
         * @param {string} datasetId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetJudgementsByDatasetId(datasetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatasetJudgementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetJudgementsByDatasetId(datasetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.getDatasetJudgementsByDatasetId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates acceptedSource, companyIdOfAcceptedQaReport and customValue of a data point within a dataset judgement.
         * @summary Patch judgement details for a data point
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {string} dataPointType The data point type of the provided data point.
         * @param {JudgementDetailsPatch} judgementDetailsPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchJudgementDetails(datasetJudgementId: string, dataPointType: string, judgementDetailsPatch: JudgementDetailsPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetJudgementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchJudgementDetails(datasetJudgementId, dataPointType, judgementDetailsPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.patchJudgementDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a new dataset judgement object.
         * @summary Upload new dataset judgement object.
         * @param {string} datasetId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDatasetJudgement(datasetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetJudgementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDatasetJudgement(datasetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.postDatasetJudgement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set yourself as the judge of the dataset judgement object. Other users cannot modify this object.
         * @summary Change the Judge of a dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setJudge(datasetJudgementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetJudgementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setJudge(datasetJudgementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.setJudge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify state of the dataset judgement object. Approves or rejects associated data set. Uploads new datapoints and approves them, rejects unneeded datapoints.
         * @summary Change the state of a dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {DatasetJudgementState} datasetJudgementState The state of the dataset judgement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setJudgementState(datasetJudgementId: string, datasetJudgementState: DatasetJudgementState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetJudgementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setJudgementState(datasetJudgementId, datasetJudgementState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatasetJudgementControllerApi.setJudgementState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatasetJudgementControllerApi - factory interface
 */
export const DatasetJudgementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasetJudgementControllerApiFp(configuration)
    return {
        /**
         * Delete dataset judgement object (and by extension data point judgement objects) without deleting the QA reports.
         * @summary Delete dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDatasetJudgement(datasetJudgementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a dataset judgement object by its id.
         * @summary Get a dataset judgement object by its id.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse> {
            return localVarFp.getDatasetJudgement(datasetJudgementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all dataset judgement objects associated with the specified dataset id.
         * @summary Get dataset judgement objects by dataset id.
         * @param {string} datasetId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetJudgementsByDatasetId(datasetId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetJudgementResponse>> {
            return localVarFp.getDatasetJudgementsByDatasetId(datasetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates acceptedSource, companyIdOfAcceptedQaReport and customValue of a data point within a dataset judgement.
         * @summary Patch judgement details for a data point
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {string} dataPointType The data point type of the provided data point.
         * @param {JudgementDetailsPatch} judgementDetailsPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJudgementDetails(datasetJudgementId: string, dataPointType: string, judgementDetailsPatch: JudgementDetailsPatch, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse> {
            return localVarFp.patchJudgementDetails(datasetJudgementId, dataPointType, judgementDetailsPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a new dataset judgement object.
         * @summary Upload new dataset judgement object.
         * @param {string} datasetId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDatasetJudgement(datasetId: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse> {
            return localVarFp.postDatasetJudgement(datasetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set yourself as the judge of the dataset judgement object. Other users cannot modify this object.
         * @summary Change the Judge of a dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJudge(datasetJudgementId: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse> {
            return localVarFp.setJudge(datasetJudgementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify state of the dataset judgement object. Approves or rejects associated data set. Uploads new datapoints and approves them, rejects unneeded datapoints.
         * @summary Change the state of a dataset judgement object.
         * @param {string} datasetJudgementId The unique identifier of the data judgment.
         * @param {DatasetJudgementState} datasetJudgementState The state of the dataset judgement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setJudgementState(datasetJudgementId: string, datasetJudgementState: DatasetJudgementState, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse> {
            return localVarFp.setJudgementState(datasetJudgementId, datasetJudgementState, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasetJudgementControllerApi - interface
 */
export interface DatasetJudgementControllerApiInterface {
    /**
     * Delete dataset judgement object (and by extension data point judgement objects) without deleting the QA reports.
     * @summary Delete dataset judgement object.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get a dataset judgement object by its id.
     * @summary Get a dataset judgement object by its id.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse>;

    /**
     * Retrieve all dataset judgement objects associated with the specified dataset id.
     * @summary Get dataset judgement objects by dataset id.
     * @param {string} datasetId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDatasetJudgementsByDatasetId(datasetId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DatasetJudgementResponse>>;

    /**
     * Updates acceptedSource, companyIdOfAcceptedQaReport and customValue of a data point within a dataset judgement.
     * @summary Patch judgement details for a data point
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {string} dataPointType The data point type of the provided data point.
     * @param {JudgementDetailsPatch} judgementDetailsPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchJudgementDetails(datasetJudgementId: string, dataPointType: string, judgementDetailsPatch: JudgementDetailsPatch, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse>;

    /**
     * Upload a new dataset judgement object.
     * @summary Upload new dataset judgement object.
     * @param {string} datasetId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDatasetJudgement(datasetId: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse>;

    /**
     * Set yourself as the judge of the dataset judgement object. Other users cannot modify this object.
     * @summary Change the Judge of a dataset judgement object.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setJudge(datasetJudgementId: string, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse>;

    /**
     * Modify state of the dataset judgement object. Approves or rejects associated data set. Uploads new datapoints and approves them, rejects unneeded datapoints.
     * @summary Change the state of a dataset judgement object.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {DatasetJudgementState} datasetJudgementState The state of the dataset judgement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setJudgementState(datasetJudgementId: string, datasetJudgementState: DatasetJudgementState, options?: RawAxiosRequestConfig): AxiosPromise<DatasetJudgementResponse>;

}

/**
 * DatasetJudgementControllerApi - object-oriented interface
 */
export class DatasetJudgementControllerApi extends BaseAPI implements DatasetJudgementControllerApiInterface {
    /**
     * Delete dataset judgement object (and by extension data point judgement objects) without deleting the QA reports.
     * @summary Delete dataset judgement object.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).deleteDatasetJudgement(datasetJudgementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a dataset judgement object by its id.
     * @summary Get a dataset judgement object by its id.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDatasetJudgement(datasetJudgementId: string, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).getDatasetJudgement(datasetJudgementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all dataset judgement objects associated with the specified dataset id.
     * @summary Get dataset judgement objects by dataset id.
     * @param {string} datasetId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDatasetJudgementsByDatasetId(datasetId: string, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).getDatasetJudgementsByDatasetId(datasetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates acceptedSource, companyIdOfAcceptedQaReport and customValue of a data point within a dataset judgement.
     * @summary Patch judgement details for a data point
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {string} dataPointType The data point type of the provided data point.
     * @param {JudgementDetailsPatch} judgementDetailsPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchJudgementDetails(datasetJudgementId: string, dataPointType: string, judgementDetailsPatch: JudgementDetailsPatch, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).patchJudgementDetails(datasetJudgementId, dataPointType, judgementDetailsPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a new dataset judgement object.
     * @summary Upload new dataset judgement object.
     * @param {string} datasetId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postDatasetJudgement(datasetId: string, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).postDatasetJudgement(datasetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set yourself as the judge of the dataset judgement object. Other users cannot modify this object.
     * @summary Change the Judge of a dataset judgement object.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setJudge(datasetJudgementId: string, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).setJudge(datasetJudgementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify state of the dataset judgement object. Approves or rejects associated data set. Uploads new datapoints and approves them, rejects unneeded datapoints.
     * @summary Change the state of a dataset judgement object.
     * @param {string} datasetJudgementId The unique identifier of the data judgment.
     * @param {DatasetJudgementState} datasetJudgementState The state of the dataset judgement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setJudgementState(datasetJudgementId: string, datasetJudgementState: DatasetJudgementState, options?: RawAxiosRequestConfig) {
        return DatasetJudgementControllerApiFp(this.configuration).setJudgementState(datasetJudgementId, datasetJudgementState, options).then((request) => request(this.axios, this.basePath));
    }
}

